var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColdemailerIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    rx: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4418 62.2603L24.6859 72.8035V51.6521L37.4418 62.1952V62.2603ZM64.9712 77.7497H27.0288C26.7034 77.7497 26.4431 77.6846 26.1827 77.5544L41.0864 65.2541L43.1039 66.9462C43.9499 67.6621 44.9262 67.9875 45.9675 67.9875C47.0088 67.9875 47.985 67.6621 48.831 66.9462L50.8486 65.2541L65.7522 77.5544C65.4919 77.6846 65.2315 77.7497 64.9061 77.7497H64.9712ZM54.5582 62.2603L67.3141 51.7171V72.8686L54.5582 62.3254V62.2603ZM61.6521 24.0576C61.6521 24.0576 55.4693 19.9574 45.9675 19.9574C36.4656 19.9574 30.2829 24.0576 30.2829 24.0576L20 10V49.0488V49.96V75.3417C20 77.6846 21.1715 79.7672 22.9937 81.0688C24.1001 81.8498 25.5319 82.3705 27.0288 82.3705H64.9712C65.6871 82.3705 66.403 82.2403 67.0538 82.0451C68.1602 81.7197 69.0713 81.1339 69.8523 80.3529C69.8523 80.3529 69.8523 80.3529 69.9174 80.2879C69.9174 80.2879 69.9174 80.2879 69.9825 80.2228C70.7635 79.4418 71.3492 78.4656 71.6746 77.4243C71.8698 76.7735 72 76.0576 72 75.3417V50.1552V49.0488V10L61.7171 24.0576H61.6521Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColdemailerIconLogo);
export default __webpack_public_path__ + "static/media/coldemailer_icon_logo.203346fa225f7c4bb18b8a51ea289811.svg";
export { ForwardRef as ReactComponent };